import styled from "styled-components";
import { ShapeEditor } from "react-shape-editor";

export const VideoShapeEditor = styled(ShapeEditor)`
    position: absolute;
    top: 0;
    left: ${({ vectorWidth }) => `calc(50% - ${vectorWidth}px / 2)`};
`;

export const VerticalProgressBar = styled.div<{ left: number; height: number }>`
    position: absolute;
    top: 0;
    left: ${({ left }) => `${left}px`};
    height: ${({ height }) => `${height}px`};
    width: 2px;
    background-color: black;
`;
